// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3INT-","largestCol":"styles_largestCol__3WFjq","smallestCol":"styles_smallestCol__3wT60"};